<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="应用名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入应用名称" v-trim/>
      </el-form-item>
      <el-form-item label="应用LOGO" prop="logo">
        <UploadAvatarImage :uploadData="uploadData" :file="file" @uploadSuccess="getFiles" />
      </el-form-item>
      <el-form-item label="应用附件" prop="mutifileUrl">
        <el-upload
          class="upload-demo"
          :action="uploadImgUrl"
          :data="uploadData"
          accept=".pdf,.jpg,.png,.jpeg,.zip,.rar"
          :limit="1"
          :on-exceed="exceed"
          :on-remove="remove"
          :on-success="getFileSuccess"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传PDF、图片、压缩包格式文件</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="服务商" prop="serverId">
        <el-select v-model="form.serverId" placeholder="请选择">
          <el-option
            v-for="item in server"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应用标签" prop="lables">
        <el-input v-model="form.lables" placeholder="请输入应用标签（多个以英文,分割）" v-trim/>
      </el-form-item>
      <el-form-item label="应用简介" prop="introduction">
        <el-input type="textarea" :autosize="{ minRows: 12, maxRows: 6 }" v-model="form.introduction" placeholder="请输入应用简介" v-trim/>
      </el-form-item>
      <el-form-item label="应用详情" prop="details">
        <RichEditor :content="{ content: form.details }" @edit="form.details = $event" :max-length="0" />
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
import { fetchList } from '@/api/business/serverProvider'
import RichEditor from '@/components/common/RichEditor'
export default {
  name: 'OperaApplicationInfoWindow',
  extends: BaseOpera,
  components: { GlobalWindow, UploadAvatarImage, RichEditor },
  data () {
    return {
      uploadImgUrl: process.env.VUE_APP_API_PREFIX + '/public/uploadPicture',
      // 表单数据
      form: {
        id: null,
        serverId: '',
        name: '',
        logo: '',
        mutifileUrl: '',
        lables: '',
        introduction: '',
        details: ''
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: '请上传', trigger: 'blur' }
        ],
        serverId: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
      },
      server: [],
      uploadData: {
        folder: 'znzz/logo_file',
        type: 'image'
      },
      file: {
        imgurl: '',
        imgurlfull: ''
      },
      fileList: []
    }
  },
  created () {
    this.config({
      api: '/business/applicationInfo',
      'field.id': 'id'
    })
  },
  methods: {
    open (title, target) {
      this.title = title
      this.file.imgurl = ''
      this.file.imgurlfull = ''
      this.fileList = []
      this.getFetchList()
      this.visible = true
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        setTimeout(() => {
          this.form.details = target.details
        }, 500)
        this.file.imgurl = target.logo
        this.file.imgurlfull = target.fullLog
        if (target.fullMutifileUrl) {
          this.fileList.push({
            name: '应用附件',
            url: target.fullMutifileUrl
          })
        }
      })
    },
    getFileSuccess(response) {
      this.form.mutifileUrl = response.data.imgaddr
      // response.data.originname
      this.fileList.push({
        name: '应用附件',
        url: response.data.url
      })
    },
    exceed() {
      this.$message.warning('只能上传一个附件')
    },
    remove() {
      this.form.mutifileUrl = ''
      this.fileList = []
    },
    getFiles(e) {
      this.file.imgurl = e.imgurl
      this.file.imgurlfull = e.imgurlfull
      this.form.logo = e.imgurl
    },
    async getFetchList() {
      let res = await fetchList({ capacity: 9999, page: 1, model: { status: 0 } })
      this.server = res.records
    }
  }
}
</script>
